export default "__VITE_ASSET__CP3VaWu2__"